import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://yxuixuejsrxhxglsoivh.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl4dWl4dWVqc3J4aHhnbHNvaXZoIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzIxODI4MTQsImV4cCI6MTk4Nzc1ODgxNH0.NkXkEvgbMqp1nNKcRbRkg81g7Xj6W_u-UFqPj7ryzTg";
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
